export default "__VITE_ASSET__Dvi0MQ0i__"